export interface FileValidator {
  validate(file: File | undefined | null): Promise<any>
}

export class FileSizeLimitError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'FileSizeLimitError'
  }
}

export type FileValidationError = FileSizeLimitError | Error

const MAX_IMAGE_SIZE = {
  maxWidth: 4096,
  maxHeight: 4096,
}

export const imageValidator = {
  validate(file: File | null | undefined): Promise<FileValidationError | void> {
    return new Promise((resolve, reject) => {
      if (!file?.type.includes('image')) return resolve()

      _createFileReader((result: string) => {
        const img = new Image()

        img.onload = () => {
          const { width, height } = img
          const { maxWidth, maxHeight } = MAX_IMAGE_SIZE
          const isSizeAboveRecommendedLimit = width > maxWidth || height > maxHeight

          if (isSizeAboveRecommendedLimit) {
            return reject(
              new FileSizeLimitError(
                `The file selected is above the recommended size limits. The selected file needs to be a maximum of ${maxWidth}x${maxHeight}.`
              )
            )
          }

          return resolve()
        }

        img.src = result
      }, file)
    })
  },
}

function _createFileReader(callback: (readerResult: string) => void, file: File) {
  const reader = new FileReader()

  reader.onload = function onload() {
    callback(reader.result as string)
  }

  reader.readAsDataURL(file)
}
